import { ITodoItem } from 'views/dashboard/insight/todos/types';
import { getTodos } from 'services/todos';
import { useQuery } from 'react-query';

export const useTodos = (accountId: string | undefined) => {
  const { data: todos, ...rest } = useQuery<ITodoItem[], unknown>(
    [
      'todos',
      {
        accountId,
      },
    ],
    () => getTodos(accountId!),
  );

  return {
    todos,
    ...rest,
  };
};

export const useLeftNavNotifications = (accountId: string | undefined) => {
  const { data: todos, ...rest } = useQuery<ITodoItem[], unknown>(
    [
      'leftNavNotification',
      {
        accountId,
      },
    ],
    () => getTodos(accountId!),
    {
      enabled: accountId !== undefined,
      refetchInterval: 60000,
      refetchIntervalInBackground: true,
    },
  );

  return {
    todos,
    ...rest,
  };
};
